"use client";
import React from "react";

import { TextField, TextFieldProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { COLOR_PRIMARY_BLACK } from "~/theme/colors";

import { DROPDOWN_CONTROL_CLASSES } from "./constants";

interface DropdownControlContainerProps {
  rect?: DOMRect;
  isTopVariant: boolean;
  isPlaceholderVisible: boolean;
}

export const DropdownControlContainer = styled(
  ({
    rect,
    isTopVariant,
    isPlaceholderVisible,
    ...restProps
  }: DropdownControlContainerProps & TextFieldProps) => <TextField {...restProps} />,
)(({ theme, rect, isTopVariant, isPlaceholderVisible }) => {
  const paperStyles = () => {
    if (rect) {
      const { top, height } = rect;
      const bottom = innerHeight - top - height;

      return {
        maxHeight: (isTopVariant ? top : bottom) - 40,
      };
    }
    return {};
  };

  const inputStyles = () => {
    if (!isPlaceholderVisible) {
      return {};
    }
    return {
      height: "100%",
      width: `calc(100% - ${theme.spacing(4)})`,
      paddingLeft: theme.spacing(1.75),
      opacity: 1,
      border: "none",
      "&::placeholder": { fontSize: 16 },
    };
  };

  return {
    "& .MuiSelect-nativeInput": inputStyles(),
    "& .MuiFormLabel-root": {
      paddingBottom: theme.spacing(1),
    },
    "& .MuiSelect-icon": {
      top: `calc(50% - ${theme.spacing(2.5)})`,
      color: COLOR_PRIMARY_BLACK,
    },
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      paddingRight: "40px",
    },
    [`& .${DROPDOWN_CONTROL_CLASSES.paper}`]: paperStyles(),
  };
});
